// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. NAD+ Initial 6/1/26 09.17.26" (d90a0315-767b-41dc-ac44-1d9bae20faf9). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiNADInitialQuestions = [
  {
    field: 'mdiNADInitial_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiNADInitial_pregnantBreastfeeding',
    label: 'Are you Pregnant or Breastfeeding?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'currently_pregnant', value: 'Currently Pregnant' },
        { key: 'currently_breastfeeding', value: 'Currently Breastfeeding' },
        {
          key: 'planning_to_become_pregnant_within_90_da',
          value: 'Planning to become pregnant within 90 days'
        },
        {
          key: 'not_pregnant_nor_breastfeeding',
          value: 'NOT Pregnant nor Breastfeeding'
        }
      ]
    },
    extras: { mdiQuestionId: '899348e6-b094-41f9-982a-83a422205215' }
  },
  {
    field: 'mdiNADInitial_urgentDuePregnancyBreastfeedingCannot',
    label:
      'URGENT: Due to Pregnancy or Breastfeeding, you cannot be medically qualified.',
    type: 'info',
    subLabel:
      'Please contact [customer_support_email] for alternative options.',
    answer: {
      type: 'text',
      name: 'mdiNADInitial_urgentDuePregnancyBreastfeedingCannot'
    },
    extras: { mdiQuestionId: '870b371b-7a40-4f24-83f9-382ba65ac0ee' }
  },
  {
    field: 'mdiNADInitial_whyInterestedNadTreatment',
    label: 'Why are you interested in NAD+ treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'chronic_fatigue_support_energy_levels',
          value: 'Chronic fatigue/support energy levels'
        },
        { key: 'longevity_benefits', value: 'Longevity benefits' },
        {
          key: 'cognitive_support_increased_focus',
          value: 'Cognitive support/increased focus'
        },
        { key: 'support_improved_sleep', value: 'Support improved sleep' },
        {
          key: 'general_recovery_athletic_support',
          value: 'General recovery/athletic support'
        },
        { key: 'neurological_benefits', value: 'Neurological benefits' },
        { key: 'metabolic_benefits', value: 'Metabolic benefits' },
        { key: 'stress_resistance', value: 'Stress resistance' },
        {
          key: 'other_please_specify_below',
          value: 'Other: (please specify below)',
          answer: {
            type: 'text',
            name: 'other_please_specify_below_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: '94dd9364-8d70-4c0b-9d2d-a8b7e99d4aa0' }
  },
  {
    field: 'mdiNADInitial_activeCancerHistoryCancer',
    label: 'Do you have active cancer or any history of cancer?',
    type: 'select',
    educationalSlide:
      'If yes, please provide as much information as possible for your doctor to review to determine if this treatment is appropriate and safe for you.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '3342f4a3-e8e7-4a0e-a4b2-874203afabab' }
  },
  {
    field: 'mdiNADInitial_historyAllergicReaction',
    label: 'Do you have any of the following?',
    type: 'select',
    educationalSlide:
      'If yes please provide as much information for your doctor to determine if this therapy is appropriate and safe for you. You may provide any recent labs for your doctor to review as well.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'history_of_allergic_reaction_or_sensitiv',
          value:
            'History of allergic reaction or sensitivity to NAD components (such as NAD, NADH, ENADA, or NAD+)',
          answer: {
            type: 'text',
            name: 'history_of_allergic_reaction_or_sensitiv_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'autoimmune_disorder_such_as_lupus_multip',
          value:
            'Autoimmune disorder (such as Lupus, Multiple Sclerosis, or other)',
          answer: {
            type: 'text',
            name: 'autoimmune_disorder_such_as_lupus_multip_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_anxiety_use_of_anti_anxiety_m',
          value:
            'History of anxiety, use of anti-anxiety medications or antidepressants',
          answer: {
            type: 'text',
            name: 'history_of_anxiety_use_of_anti_anxiety_m_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_kidney_disease_or_being_on_di',
          value: 'History of kidney disease or being on dialysis',
          answer: {
            type: 'text',
            name: 'history_of_kidney_disease_or_being_on_di_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_liver_disease_or_cirrhosis',
          value: 'History of liver disease or cirrhosis',
          answer: {
            type: 'text',
            name: 'history_of_liver_disease_or_cirrhosis_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_heart_disease_heart_attack_he',
          value:
            'History of heart disease (heart attack, heart failure, abnormal heart rhythm, etc)',
          answer: {
            type: 'text',
            name: 'history_of_heart_disease_heart_attack_he_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'uncontrolled_high_blood_pressure',
          value: 'Uncontrolled high blood pressure',
          answer: {
            type: 'text',
            name: 'uncontrolled_high_blood_pressure_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'chest_pain_or_shortness_of_breath_with_e',
          value: 'Chest pain or shortness of breath with exertion',
          answer: {
            type: 'text',
            name: 'chest_pain_or_shortness_of_breath_with_e_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'blood_thinner_use_like_warfarin',
          value: 'Blood thinner use (like warfarin)',
          answer: {
            type: 'text',
            name: 'blood_thinner_use_like_warfarin_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '6389f1f7-4146-42a8-b2dd-eb7fabaa08a1' }
  },
  {
    field: 'mdiNADInitial_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent  (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiNADInitial_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: '59159205-5392-40c3-92f3-dc87329e9921' }
  },
  {
    field: 'mdiNADInitial_elseLikeTellDoctorWho',
    label:
      'What else would you like to tell the doctor who will be evaluating you? This is your first message to your doctor.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiNADInitial_elseLikeTellDoctorWho',
      rows: 4,
      placeholder:
        'Example: "Hi doctor, other than what I already answered I am otherwise health and excited to get started."'
    },
    extras: { mdiQuestionId: 'baed0e81-0e30-45a0-ab45-dff132bed274' }
  },
  {
    field: 'mdiNADInitial_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiNADInitialAnswerField = Partial<
  QuestionAnswerMap<typeof mdiNADInitialQuestions>
>;

export default mdiNADInitialQuestions;
